import React from "react";
import ReactDOM from "react-dom";
import DictionaryCombobox, { IProps as IDictionaryComboboxProps } from "../controls/Comboboxs/DictionaryCombobox";
import GroupCombobox, { IProps as IGroupComboboxProps } from "../controls/Comboboxs/GroupCombobox";
import UserCombobox, { IProps as IUserComboboxProps } from "../controls/Comboboxs/UserCombobox";
import RelatedIssueCombobox, { IProps as IRelatedIssueComboboxProps } from "../controls/Comboboxs/RelatedIssueCombobox";
import WorkCostExpandableForm, { IProps as IWorkCostFormProps } from "../controls/Comboboxs/WorkCostForm";
import ResourcesDataCombobox, { IProps as IResourcesDataComboboxProps } from "../controls/Comboboxs/ResourcesDataCombobox";

import LogPlusResources from "../controls/LogPlusResourcesDataControl/LogPlusResources";
import { IIssueWorkflowData, IWorkflowContext, WorkflowContext } from "./WorkflowContext";

import PersonProfileRelations from '../controls/PersonProfileRelations';
import AccessRelations from '../controls/AccessRelation';
import AuthorizationRelations from '../controls/AuthorizationRelation';

import "./WorkflowFormControls.css"

import { ControlType } from "../controls/ResourcesControl/Models";

interface IProps {
	divRef: React.MutableRefObject<HTMLDivElement>,
	reload: number,
	isTransient: boolean,
}

export default function WorkflowFormControls(props: IProps) {
	const [issueWorkflowData, setIssueWorkflowData] = React.useState<IIssueWorkflowData>({});
	const [portals, setPortals] = React.useState<React.ReactPortal[]>([]);
	const { divRef } = props;
	React.useEffect(() => {
		if (divRef.current) {
			let controls = [];

			let nodes = divRef.current.querySelectorAll('div.react-portal-log-plus-resources');

			for (var i = 0; i < nodes.length; i++) {
				let node = nodes[i] as HTMLDivElement;

				let issueId: number = null;
				if (node.dataset.issueId)
					issueId = parseInt(node.dataset.issueId);

				controls.push(ReactDOM.createPortal(<LogPlusResources
					key={"react-portal-log-plus-resources-" + i}

					issueId={issueId}
					name={node.dataset.name}
					value={node.dataset.value}
					controlId={node.dataset.controlId}
					errorText={node.dataset.errorText}
					multiple={node.dataset.multiple === "True"}
					kinds={node.dataset.kinds}
					mode={node.dataset.mode as ('' | 'relatedUser' | 'relatedNotifier')}
					searchIn={node.dataset.searchIn}
					showGridTabs={node.dataset.showGridTabs}

					relatedFilterId={node.dataset.relatedFilterId}
					filterId={node.dataset.filterId}
					manageFiltersPermission={node.dataset.manageFiltersPermission === "True"}
					gridColumns={node.dataset.gridColumns && JSON.parse(node.dataset.gridColumns)}
					relatedGridColumns={node.dataset.relatedGridColumns && JSON.parse(node.dataset.relatedGridColumns)}
				/>, node));
			}

			let usersComboboxs = divRef.current.querySelectorAll(".react-users-combobox");
			for (var i = 0; i < usersComboboxs.length; i++) {
				let node = usersComboboxs[i] as HTMLDivElement;
				controls.push(ReactDOM.createPortal(<WorkflowUserCombobox
					key={"react-portal-users-combobox-" + node.dataset.name}
					name={node.dataset.name}
					refControl={node.dataset.refControl}
					errorText={node.dataset.errorText}
					filter={node.dataset.filter}
					filterGroup={node.dataset.filterGroup}
					maxRows={parseInt(node.dataset.maxRows)}
					counters={node.dataset.counters}
				/>, node));
			}

			let groupsComboboxs = divRef.current.querySelectorAll(".react-groups-combobox");
			for (var i = 0; i < groupsComboboxs.length; i++) {
				let node = groupsComboboxs[i] as HTMLDivElement;
				controls.push(ReactDOM.createPortal(<WorkflowGroupCombobox
					key={"react-portal-groups-combobox-" + i}
					name={node.dataset.name}
					refControl={node.dataset.refControl}
					filter={node.dataset.filter}
					errorText={node.dataset.errorText}
					counters={node.dataset.counters}
				/>, node));
			}

			let dictionaryComboboxs = divRef.current.querySelectorAll(".react-dictionary-combobox");
			for (var i = 0; i < dictionaryComboboxs.length; i++) {
				let node = dictionaryComboboxs[i] as HTMLDivElement;

				controls.push(ReactDOM.createPortal(<WorkflowDictionaryCombobox
					key={"react-portal-dictionary-combobox-" + i}
					name={node.dataset.name}
					refControl={node.dataset.refControl}
					dictionaryType={node.dataset.dictionaryType}
					parentDictionaryId={node.dataset.parentDictionaryId}
					errorText={node.dataset.errorText}
				/>, node));
			}

			let workCostForm = divRef.current.querySelectorAll(".react-work-cost-form");
			for (var i = 0; i < workCostForm.length; i++) {
				let node = workCostForm[i] as HTMLDivElement;

				controls.push(ReactDOM.createPortal(<WorkflowDataCostForm
					key={"react-work-cost-form-" + i}
					name={node.dataset.name}
					refControl={node.dataset.refControl}
					editUser={node.dataset.editUser === "True"}
					open={node.dataset.open === "True"}
					errorText={node.dataset.errorText}
				/>, node));
			}

			let relatedIssueCombobox = divRef.current.querySelectorAll(".react-related-issue-combobox");
			for (var i = 0; i < relatedIssueCombobox.length; i++) {
				let node = relatedIssueCombobox[i] as HTMLDivElement;

				controls.push(ReactDOM.createPortal(<WorkflowRelatedIssueCombobox
					key={"react-related-issue-combobox-" + i}
					name={node.dataset.name}
					refControl={node.dataset.refControl}
					errorText={node.dataset.errorText}
				/>, node));
			}

			let resourcesDataCombobox = divRef.current.querySelectorAll(".react-resources-data-combobox");
			for (var i = 0; i < resourcesDataCombobox.length; i++) {
				let node = resourcesDataCombobox[i] as HTMLDivElement;

				controls.push(ReactDOM.createPortal(<WorkflowResourcesDataCombobox
					key={"react-resources-data-" + i}
					refControl={node.dataset.refControl}
					name={node.dataset.name}
					errorText={node.dataset.errorText}

					kind={node.dataset.kind}
					multiple={node.dataset.multiple == "True"}
					filterId={node.dataset.filterId}
					filters={node.dataset.filters}
					controlNotifierId={node.dataset.controlNotifierId}
					controlType={node.dataset.controlType as ControlType}
					showGridTabs={node.dataset.showGridTabs}

					employeesSource={node.dataset.employeesSource}
					requestId={node.dataset.requestId}
					isModal={node.dataset.isModal == "True"}

					resourcesGridColumns={JSON.parse(node.dataset.resourcesGridColumns ?? "null")}
					relatedResourcesGridColumns={JSON.parse(node.dataset.relatedResourcesGridColumns ?? "null")}
					relatedEmployeesResourcesGridColumns={JSON.parse(node.dataset.relatedEmployeesResourcesGridColumns ?? "null")}
					servicesGridColumns={JSON.parse(node.dataset.servicesGridColumns ?? "null")}

					isLogSystemIntegrationAvailable={node.dataset.isLogSystemIntegrationAvailable == "True"}
					isLogPlusIntegrationAvailable={node.dataset.isLogPlusIntegrationAvailable == "True"}
					isDemo={node.dataset.isDemo == "True"}
					manageFiltersPermission={node.dataset.manageFiltersPermission == "True"}

					maxRows={parseInt(node.dataset.maxRows)}
				/>, node));
			}

			let personProfileDataNodes = divRef.current.querySelectorAll(".react-profile-resource-relations-data");
			for (var i = 0; i < personProfileDataNodes.length; i++) {
				let node = personProfileDataNodes[i] as HTMLDivElement;

				controls.push(PersonProfileRelations(node, i));
			}

			let authorizationDataNodes = divRef.current.querySelectorAll(".react-authorization-resource-relations-data");
			for (var i = 0; i < authorizationDataNodes.length; i++) {
				let node = authorizationDataNodes[i] as HTMLDivElement;

				controls.push(AuthorizationRelations(node, i));
			}

			let accessDataNodes = divRef.current.querySelectorAll(".react-access-resource-relations-data");
			for (var i = 0; i < accessDataNodes.length; i++) {
				let node = accessDataNodes[i] as HTMLDivElement;

				controls.push(AccessRelations(node, i));
			}

			setPortals(controls);
		}
	}, [divRef.current, props.reload]);
	const ctx: IWorkflowContext = {
		issueWorkflowData,
		setIssueWorkflowData: (data: IIssueWorkflowData) => {
			setIssueWorkflowData(data);
		},
		isTransient: props.isTransient,
		setIssueWorkflowDataByName: (propertName, value) => {
			issueWorkflowData[propertName] = value;
			const temp = { ...issueWorkflowData };
			setIssueWorkflowData(temp);
		},
	};
	return (<WorkflowContext.Provider value={ctx}>
		{portals}
	</WorkflowContext.Provider>)
}

export function WorkflowDictionaryCombobox(props: IDictionaryComboboxProps) {
	return <WorkflowContext.Consumer>
		{(ctx: IWorkflowContext) => (
			<DictionaryCombobox {...props} onSet={(value) => {
				ctx.setIssueWorkflowDataByName(props.name, value);
			}} />
		)}
	</WorkflowContext.Consumer>
}

export function WorkflowGroupCombobox(props: IGroupComboboxProps) {
	return <WorkflowContext.Consumer>
		{({ setIssueWorkflowDataByName }) => (
			<GroupCombobox {...props} onSet={(value) => {
				setIssueWorkflowDataByName(props.name, value);
			}} />
		)}
	</WorkflowContext.Consumer>
}

export function WorkflowUserCombobox(props: IUserComboboxProps) {
	return <WorkflowContext.Consumer>
		{(ctx: IWorkflowContext) => (
			<UserCombobox {...props} onSet={(value) => {
				ctx.setIssueWorkflowDataByName(props.name, value);
			}} />
		)}
	</WorkflowContext.Consumer>
}

export function WorkflowDataCostForm(props: IWorkCostFormProps) {
	return <WorkflowContext.Consumer>
		{({ setIssueWorkflowDataByName }) => (
			<WorkCostExpandableForm {...props} onSet={(value) => {
				setIssueWorkflowDataByName(props.name, value);
			}} />
		)}
	</WorkflowContext.Consumer>
}

export function WorkflowRelatedIssueCombobox(props: IRelatedIssueComboboxProps) {
	return <WorkflowContext.Consumer>
		{({ setIssueWorkflowDataByName }) => (
			<RelatedIssueCombobox {...props} onSet={(value) => {
				setIssueWorkflowDataByName(props.name, value);
			}} />
		)}
	</WorkflowContext.Consumer>
}

export function WorkflowResourcesDataCombobox(props: IResourcesDataComboboxProps) {
	return <WorkflowContext.Consumer>
		{({ issueWorkflowData, setIssueWorkflowDataByName }) => (
			<ResourcesDataCombobox
				{...props}
				issueWorkflowData={issueWorkflowData}
				onSet={(value) => {
					setIssueWorkflowDataByName(props.name, value);
				}}
			/>
		)}
	</WorkflowContext.Consumer>
}